<template>
	<v-container fluid>
        <v-form ref="filters">
            <v-row align="start" dense>
                <v-col cols="2">
                    <v-autocomplete
                        v-model="csTipoUep"
                        :items="uepTypes"
                        :menu-props="{
                        offsetY: true,
                        bottom: true
                        }"
                        label="Tipo de Unidade Exploração"
                        no-data-text="Nenhum registro"
                        color="primary"
                        item-text="dsTipoUep"
                        item-value="csTipoUep"
                        outlined
                        clearable
                        hide-details
                    />
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="cdUepOrigem"
                        :items="listaUepOrigem"
                        :loading="loadingUepOrigem"
                        color="primary"
                        item-text="displayText"
                        item-value="idUnidadeExploracao"
                        label="Origem"
                        no-data-text="Selecione a Unidade de Exploração"
                        outlined
                        clearable
                    />
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        label="Extensionista"
                        outlined
                        clearable
                        hide-details
                        v-model="cdResponsavelTecnico"
                        :items="technicalManagers"
                        item-text="nmPessoa"
                        item-value="idResponsavelTecnico"
                        :loading="loadingTechnicalManagers"
                    />
                </v-col>
                <v-col cols="2">
                    <v-autocomplete
                            v-model="csStatus"
                            :items="statusTypes"
                            color="primary"
                            item-text="dsStatus"
                            item-value="csStatus"
                            label="Status do Lote"
                            no-data-text="Nenhum registro"
                            outlined
                            clearable>
                    </v-autocomplete>
                </v-col>
                <v-col cols="2">
                    <v-autocomplete
                        v-model="sgSexo"
                        :items="genderTypes"
                        color="primary"
                        item-text="dsSexo"
                        item-value="sgSexo"
                        label="Gênero dos animais"
                        clearable
                        outlined
                    />
                </v-col>
                <v-col cols="3">
                    <analises-menu-date-picker
                        label="Mortalidades de"
                        outlined
                        v-model="dtInicioMortalidade"
                            :error-messages="dtInicioMortalidadeErrors"
                            :maxDate="maxDateInicioMortalidade"
                    />
                </v-col>
                <v-col cols="3">
                    <analises-menu-date-picker
                        label="Mortalidades até"
                        outlined
                        v-model="dtFimMortalidade"
                        :error-messages="dtFimMortalidadeErrors"
                        :minDate="minDateFimMortalidade"
                    />
                </v-col>
                <v-col cols="3">
                    <analises-menu-date-picker
                        label="Alojamentos em"
                        outlined dateType="month"
                        v-model="mesAlojamento"
                        display-format="MM/Y"
                    />
                </v-col>
                <v-col cols="3">
                    <analises-menu-date-picker
                        label="Finalizado em"
                        outlined  dateType="month"
                        v-model="mesFechamento"
                        display-format="MM/Y"
                    />
                </v-col>
                <!-- <v-col cols="2">
                    <v-autocomplete
                        v-model="nrSemana"
                        :items="weekTypes"
                        color="primary"
                        item-text="dsSemana"
                        item-value="nrSemana"
                        label="Idade do Lote até"
                        clearable
                        outlined
                    />
                </v-col> -->
                <v-col cols="3">
                    <v-autocomplete
                        v-model="cdTipoComedouro"
                        :items="tiposComedouro"
                        color="primary"
                        item-text="nmTipoComedouro"
                        item-value="idTipoComedouro"
                        label="Comedouro"
                        no-data-text="Nenhum registro"
                        outlined
                        clearable
                    />
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="cdTipoBebedouro"
                        :items="tiposBebedouro"
                        color="primary"
                        item-text="nmTipoBebedouro"
                        item-value="idTipoBebedouro"
                        label="Bebedouro"
                        no-data-text="Nenhum registro"
                        outlined
                        clearable
                    />
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="cdTipoPiso"
                        :items="tiposPiso"
                        color="primary"
                        item-text="nmTipoPiso"
                        item-value="idTipoPiso"
                        label="Piso"
                        no-data-text="Nenhum registro"
                        outlined
                        clearable>
                    </v-autocomplete>
                </v-col>
                <v-col cols="3" >
                    <v-row align="center" justify="center">
                        <v-btn dark rounded color="primary" style="margin: 5px; margin-top: 0px;"
                            @click="onApplyClick">
                            Atualizar
                            <v-icon small right>fa-sync-alt</v-icon>
                        </v-btn>
                        <v-btn rounded color="#e8e8e8" style="margin: 5px; margin-top: 0px;" @click="onClearFilters">
                            Limpar filtros
                            <v-icon small right>fas fa-eraser</v-icon>
                        </v-btn>
                        <v-btn dark rounded color="#FF5252" style="margin: 5px; margin-top: 0px;" @click="onRemoveComparativos">
                            Remover gráficos comparativos
                            <v-icon small right>fas fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
	</v-container>
</template>

<script>
import AnalisesMenuDatePicker from "../../common/components/AnalisesMenuDatePicker";
import { validationMixin } from 'vuelidate';
import moment from 'moment';
import requiredIf from 'vuelidate/lib/validators/requiredIf';
import axios from "axios";
import {URLS} from "@/modules/MortalityCauses/api/urls";

export default {
	name: 'MortalityCausesFilters',
	mixins: [validationMixin],
	validations() {
		return {
			dtInicioMortalidade: {
				required: requiredIf('dtFimMortalidade'),
			},
			dtFimMortalidade: {
				required: requiredIf('dtInicioMortalidade')
			},
		};
	},
	components: { AnalisesMenuDatePicker },
	data: () => ({
		cdResponsavelTecnico: 0,
        cdUepOrigem: 0,
        cdTipoComedouro: 0,
        cdTipoBebedouro: 0,
        cdTipoPiso: 0,

        tiposComedouro: [],
        tiposBebedouro: [],
        tiposPiso: [],
		technicalManagers: [],
        listaUepOrigem: [],
        listaEstabelecimento: [],

        csStatus: '',
		csTipoUep: '',
        sgSexo: '',
        nrSemana: null,

        dtInicioMortalidade: null,
        dtFimMortalidade: null,
        mesAlojamento: null,
        mesFechamento: null,

        loadingUepOrigem: false,
		loadingTechnicalManagers: false,
	}),
	computed: {
        uepTypes() {
            return [
                {csTipoUep: 'CR', dsTipoUep: 'Creche'},
                {csTipoUep: 'TR', dsTipoUep: 'Terminação'},
                {csTipoUep: 'WF', dsTipoUep: 'Wean to Finish'},
                {csTipoUep: 'UP', dsTipoUep: 'UPL'}
            ];
        },
        statusTypes() {
            return [
                {csStatus: 'AB', dsStatus: 'Aberto'},
                {csStatus: 'FE', dsStatus: 'Fechado'}
            ];
        },
        genderTypes() {
            return [
                {sgSexo: 'MA', dsSexo: 'Macho'},
                {sgSexo: 'FE', dsSexo: 'Fêmea'},
                {sgSexo: 'MI', dsSexo: 'Misto'}
            ];
        },
        weekTypes() {
            return [
                {nrSemana: 1, dsSemana: 'Semana 1'},
                {nrSemana: 2, dsSemana: 'Semana 2'},
                {nrSemana: 3, dsSemana: 'Semana 3'},
                {nrSemana: 4, dsSemana: 'Semana 4'},
                {nrSemana: 5, dsSemana: 'Semana 5'},
                {nrSemana: 6, dsSemana: 'Semana 6'},
                {nrSemana: 7, dsSemana: 'Semana 7'},
                {nrSemana: 8, dsSemana: 'Semana 8'},
                {nrSemana: 9, dsSemana: 'Semana 9'},
                {nrSemana: 10, dsSemana: 'Semana 10'},
                {nrSemana: 11, dsSemana: 'Semana 11'},
                {nrSemana: 12, dsSemana: 'Semana 12'},
                {nrSemana: 13, dsSemana: 'Semana 13'},
                {nrSemana: 14, dsSemana: 'Semana 14'},
                {nrSemana: 15, dsSemana: 'Semana 15'},
                {nrSemana: 16, dsSemana: 'Semana 16'},
                {nrSemana: 17, dsSemana: 'Semana 17'},
                {nrSemana: 18, dsSemana: 'Semana 18'},
                {nrSemana: 19, dsSemana: 'Semana 19'},
                {nrSemana: 20, dsSemana: 'Semana 20'},
                {nrSemana: 21, dsSemana: 'Semana 21'}
            ];
        },
        dtInicioMortalidadeErrors() {
            const errors = [];
            if (!this.$v.dtInicioMortalidade.$dirty) return errors
            !this.$v.dtInicioMortalidade.required && errors.push("Necessário informar data 'Mortalidade de'.");
            return errors
        },
        dtFimMortalidadeErrors() {
            const errors = [];
            if (!this.$v.dtFimMortalidade.$dirty) return errors
            !this.$v.dtFimMortalidade.required && errors.push("Necessário informar data 'Mortalidade até'.");
            return errors
        },
        minDateFimMortalidade() {
            const inicio = moment(this.dtInicioMortalidade, 'DD/MM/YYYY')
            return inicio.isValid() ? inicio.format('DD/MM/YYYY') : ''
        },
        maxDateInicioMortalidade() {
            const fim = moment(this.dtFimMortalidade, 'DD/MM/YYYY')
            return fim.isValid() ? fim.format('DD/MM/YYYY') : ''
        },
    },
    watch: {
        csTipoUep(nv) {
            nv ? this.loadListaUepOrigem() : this.listaUepOrigem = []
        }
    },
	methods: {
        onRemoveComparativos() {
            this.$emit('removeComparativos')
        },
		onApplyClick() {
			this.$v.$touch();
			if (this.$v.$invalid) return;
			const query = {};
            if (this.dtInicioMortalidade)
                query['dtInicio'] = moment(this.dtInicioMortalidade, "DD/MM/YYYY").format('YYYY-MM-DD')
            if (this.dtFimMortalidade)
                query['dtFim'] = moment(this.dtFimMortalidade, "DD/MM/YYYY").format('YYYY-MM-DD')
            if (this.mesAlojamento) {
                query['dtInicioAlojamento'] = moment(this.mesAlojamento, "MM/YYYY").startOf('month').format('YYYY-MM-DD')
                query['dtFimAlojamento'] = moment(this.mesAlojamento, "MM/YYYY").endOf('month').format('YYYY-MM-DD')
            }
            if (this.mesFechamento) {
                query['dtInicioFechamento'] = moment(this.mesFechamento, "MM/YYYY").startOf('month').format('YYYY-MM-DD')
                query['dtFimFechamento'] = moment(this.mesFechamento, "MM/YYYY").endOf('month').format('YYYY-MM-DD')
            }
            if (this.dtInicioFechamento)
                query['dtInicioFechamento'] = moment(this.dtInicioFechamento, "DD/MM/YYYY").format('YYYY-MM-DD')
            if (this.dtFimFechamento)
                query['dtFimFechamento'] = moment(this.dtFimFechamento, "DD/MM/YYYY").format('YYYY-MM-DD')
			if (this.csTipoUep && this.csTipoUep !== '')
				query['csTipoUep'] = this.csTipoUep;
			if (this.cdUepOrigem && this.cdUepOrigem > 0)
				query['cdUepOrigem'] = this.cdUepOrigem;
			if (this.cdResponsavelTecnico  && this.cdResponsavelTecnico  !== 0)
				query['cdResponsavelTecnico'] = this.cdResponsavelTecnico ;
			if (this.cdTipoComedouro  && this.cdTipoComedouro  !== 0)
				query['cdTipoComedouro'] = this.cdTipoComedouro ;
			if (this.cdTipoBebedouro  && this.cdTipoBebedouro  !== 0)
				query['cdTipoBebedouro'] = this.cdTipoBebedouro ;
			if (this.cdTipoPiso  && this.cdTipoPiso !== 0)
				query['cdTipoPiso'] = this.cdTipoPiso ;
			if (this.csTipoUep && this.csTipoUep !== '')
				query['csTipoUep'] = this.csTipoUep
			if (this.sgSexo && this.sgSexo !== '')
				query['sgSexo'] = this.sgSexo ;
			if (this.csStatus && this.csStatus !== '')
				query['flAberto'] = this.csStatus === 'AB';
            if (this.nrSemana && this.nrSemana !== null)
				query['nrSemana'] = this.nrSemana ;

			if (Object.keys(query).length === 0) this.$emit('apply', null);
			else this.$emit('apply', query, this.listaUepOrigem, this.technicalManagers, this.tiposComedouro, this.tiposBebedouro, this.tiposPiso);
		},
		listTechnicalManagers() {
			this.loadingTechnicalManagers = true;

			this.$axios
				.get( URLS.TECHNICAL_MANAGERS )
				.then(res => {
					if (!res.data) return;
					if (!res.data[0]) return;
					if (!res.data[0].data) return;

					this.technicalManagers = res.data[0].data;
				})
				.catch(error => {
					this.$store.commit('setSnack', {
						type: 'error',
						msg: error
					});
				})
				.finally(() => (this.loadingTechnicalManagers = false));
		},
        loadTiposComedouro() {
            axios
                .get(URLS.API_ESTABELECIMENTO + URLS.TIPO_COMEDOURO)
                .then(response => {
                    this.tiposComedouro = response.data ? response.data : [];
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error});
                })
        },
        loadTiposBebedouro() {
            axios
                .get(URLS.API_ESTABELECIMENTO + URLS.TIPO_BEBEDOURO)
                .then(response => {
                    this.tiposBebedouro = response.data ? response.data : [];
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error});
                })
        },
        loadTiposPiso() {
            axios
                .get(URLS.API_ESTABELECIMENTO + URLS.TIPO_PISO)
                .then(response => {
                    this.tiposPiso = response.data ? response.data : [];
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error});
                })
        },
        loadListaUepOrigem() {
            const toUEPOrigemView = function (est, value) {
                let match = est.find((x) => x.idEstabelecimento === value.cdEstabelecimento)
                if (match) {
                    return {
                        displayText: match.nmEstabelecimento + ' - UEP ' + value.nrUnidadeExploracao,
                        idUnidadeExploracao: value.idUnidadeExploracao
                    }
                }
            }

            this.loadingUepOrigem = true;
            this.listaUepOrigem = [{displayText: "Carregando..."}];

            axios
                .get(URLS.ESTABELECIMENTO_LOTES_ATIVOS,
                    {params: {
                        csTipoUnidadeExploracao: this.csTipoUep
                    }})
                .then(response => {
                    if (!response.data[0].data) {
                        this.listaUepOrigem = [{displayText: "Nenhum registro encontrado"}];
                        return;
                    } 
                    if (response.data[0].data.length === 0) return;

                    this.listaUepOrigem = response.data[0].data.map(est => toUEPOrigemView(this.listaEstabelecimento, est))
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error})
                })
                .finally(() => {
                    this.loadingUepOrigem = false
                    this.listaUepOrigem = this.listaUepOrigem.length > 0 ? this.listaUepOrigem : [{displayText: 'Nenhum Registro Encontrado'}]

                })
        },
        loadEstabelecimentos() {
            axios
                .get(URLS.API_ESTABELECIMENTO + URLS.ESTABELECIMENTO)
                .then(response => {
                    this.listaEstabelecimento = response.data ? response.data : [];
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error});
                })
        },
        onClearFilters() {
		    this.$refs.filters.reset();
		    this.$v.$reset();
        }
	},
	mounted() {
		this.listTechnicalManagers();
        this.loadTiposComedouro();
        this.loadTiposBebedouro();
        this.loadTiposPiso();
        this.loadEstabelecimentos();
	}
};
</script>

<style scoped></style>
